import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngExpandIcon extends ngElement
{
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {

		const type	= this.getAttribute("type")		|| "sphere";
		const size	= this.getAttribute("size")		|| this.getAttribute("width") || this.getAttribute("height") || "8";
		const width	= this.getAttribute("width")	|| this.getAttribute("size") || "8";
		const height= this.getAttribute("height")	|| this.getAttribute("size") || "8";
		const color	= this.getAttribute("color")	|| "gray";
		//var src	= this.getAttribute("src")		|| "";

		var el = "";
		switch (type) {
		case "sphere":
			el = `<div class="ng-expand-icon-sphere" style="width: ${size}px; height: ${size}px; background: radial-gradient(circle farthest-corner at 33% 33%, white 0%, ${color} 80%), radial-gradient(circle farthest-corner at 45% 45%, rgba(0, 0, 0, 0) 50%, #000000 80%);" />`;
			break;
			
		case "circle":
			var round		= Number(size) / 2;
			var stroke		= this.getAttribute("stroke") || "#666";
			var strokeWidth	= Number(this.getAttribute("stroke-width") || 0);
			var cx = round + strokeWidth;
			var cy = round + strokeWidth;
			
			el = `
				<svg class="ng-expand-icon-circle" viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
					<circle fill="${color}" stroke="${stroke}" stroke-width="${strokeWidth}" cx="${cx}" cy="${cy}" r="${round}"/>
				</svg>
			`;
			break;
			
		case "rect":
			el = `
				<svg class="ng-expand-icon-rect" viewBox="0 0 ${width} ${height}" width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
					<rect width="${width}" height="${height}" x="0" y="0" rx="0" ry="0" fill="${color}" />
				</svg>
			`;
			break;
			
		case "check":
			el = `
				<svg class="ng-expand-icon-check" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="${color}" viewBox="0 0 16 16">
					<path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
				</svg>
			`;
			break;
			
		case "svg":
			el = '<div class="ng-expand-icon-svg"></div>';
			break;

		case "img":
			el = `
				<img class="ng-expand-icon-img" width="${width}" height="${height}" />
			`;
			break;
		}

		this.shadowRoot.innerHTML = `
			<style>
				:host {
					width: ${width};
					height: ${height};
				}
			</style>
			
			${el}
		`;

		super.connectedCallback();
		
		new MutationObserver((entries, observer) => {
			for (var entry  of entries) {
				if (entry.type != "attributes") continue;
				switch (entry.attributeName) {
				case "color":
					switch (type) {
					case "sphere":
						$("div", this.shadowRoot).css({
							"background": `radial-gradient(circle farthest-corner at 33% 33%, white 0%, ${this.getAttribute(entry.attributeName)} 80%), radial-gradient(circle farthest-corner at 45% 45%, rgba(0, 0, 0, 0) 50%, #000000 80%)`,
						});
						break;
						
					case "circle":
					case "rect":
					case "check":
					case "svg":
						ninegrid.j.querySelectorAll("circle,rect,svg", this.shadowRoot).attr("fill", this.getAttribute(entry.attributeName));
						break;
					}
					break;
					
				case "src":
					switch (type) {
					case "svg":
						this.shadowRoot.querySelector("div").innerHTML = this.getAttribute(entry.attributeName);
						break;
					case "img":
						 ninegrid.j.querySelectorAll("img", this.shadowRoot).attr("src", this.getAttribute(entry.attributeName));
						break;
					}
					break;
				}
			}
		}).observe(this, {
			childList: false,
			subtree: false,
			attributeOldValue: true,
		});
	};
}

class ngExpandCheck extends ngElement
{
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {

		this.shadowRoot.innerHTML = `
			<input type="checkbox" />
		`;

		super.connectedCallback();
	};
}

class ngExpandButton extends ngElement
{
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {

		this.shadowRoot.innerHTML = `
			<button>...</button>
		`;

		super.connectedCallback();
	};
}

if (!customElements.get('ng-expand-icon')) {
	customElements.define("ng-expand-icon", ngExpandIcon);
}

if (!customElements.get('ng-expand-check')) {
	customElements.define("ng-expand-check", ngExpandCheck);
}

if (!customElements.get('ng-expand-button')) {
	customElements.define("ng-expand-button", ngExpandButton);
}


